import React, { useEffect, useState } from 'react';
import MasterPage from '../../components/MasterPage';
import { Card, Container, Row, Col, Form } from 'react-bootstrap';
import { AttachMoney } from '@material-ui/icons';
import FundsRequest from '../../services/funds-request';
import Loading from '../../components/Loading';

import * as rebateColor from '../../images/rebate-color.png';
import * as marketingColor from '../../images/marketing-color.png';
import * as fundsIcon from '../../images/reports/funds.png';
import * as redeem from '../../images/reports/redeem.png';

export default function(){
	const [fiscalYear, setFiscalYear] = useState("2021");
	const [isLoading, setIsLoading] = useState(false);
	const [funds, setFunds] = useState({
		value_mkt: 0,
		value_desmerc: 0,
		value_rebate: 0,
		value_total: 0
	});

	useEffect(() => {
		setIsLoading(true)
		
		FundsRequest.getTotalCollected({params: { fiscal_year: fiscalYear }})
			.then(({ data }) => setFunds(data))
			.finally(() => setIsLoading(false))
	},[fiscalYear])

	const formatValue = value => {
		return Intl.NumberFormat('pt-Br', { 
			style: 'currency', 
			currency: 'BRL' 
		})
		.format(value)
	}
	return (
		<Container>
			<Row className="mt-4">
				<AttachMoney className="icon-title" />
				<span className="h5">Financeiro - Total por Tipo de Verba</span>
			</Row>			
			<hr className="line"></hr>
			<Row>
				<Col>
					<Card.Body className="shadow bg-white rounded m-2 p-5 col-12">
						<Form.Group className="col-6">
							<Form.Label>Ano Fiscal:</Form.Label>
							<Form.Control
								value={fiscalYear}
								as="select"
								onChange={(event) => {
									setFiscalYear(event.target.value)
								}}
							>
								<option value="2021">2021</option>
								<option value="2020">2020</option>
								<option value="2019">2019</option>
							</Form.Control>
						</Form.Group>
					</Card.Body>
				</Col>
			</Row>
			<Row>
					<Col md="3">
						<Card.Body className="shadow bg-white font-weight-bold rounded m-2 p-5 col-12 d-flex align-items-center flex-column">
							{isLoading ? (
								<Loading page/>
							) : (
								<>
									<img className="d-inline-block mb-3" src={marketingColor} alt="" width="50" />
									<p>Marketing</p>
									<p>{ formatValue(funds.value_mkt) }</p>
								</>
							)}							
						</Card.Body>
					</Col>
					<Col md="3">
						<Card.Body className="shadow bg-white font-weight-bold rounded m-2 p-5 col-12 d-flex align-items-center flex-column">
							{isLoading ? (
								<Loading page/>
							) : (
								<>
									<img className="d-inline-block mb-3" src={rebateColor} alt="" width="50" />
									<p>Rebate</p>
									<p>{ formatValue(funds.value_rebate) }</p>
								</>
							)}
						</Card.Body>
					</Col>
					<Col md="3">
						<Card.Body className="shadow bg-white font-weight-bold rounded m-2 p-5 col-12 d-flex align-items-center flex-column">
							{isLoading ? (
								<Loading page/>
							) : (
								<>
									<img className="d-inline-block mb-3" src={fundsIcon} alt="" width="50" />
									<p>Des. Mercado</p>
									<p>{ formatValue(funds.value_desmerc) }</p>
								</>
							)}
						</Card.Body>
					</Col>
					<Col md="3">
						<Card.Body className="shadow bg-white font-weight-bold rounded m-2 p-5 col-12 d-flex align-items-center flex-column">
							{isLoading ? (
								<Loading page/>
							) : (
								<>
									<img className="d-inline-block mb-3" src={redeem} alt="" width="50" />
									<p>Total</p>
									<p>{ formatValue(funds.value_total) }</p>
								</>
							)}
						</Card.Body>
					</Col>
			</Row>
		</Container>
	);
}